export class CallBackModel {
  reason: string;
  situation: any;
  lastName: string;
  firstName: string;
  relationId: string;
  postalCode: string;
  houseNumber: string;
  address: string;
  city: string;
  country = null;
  countryId : string;
  journeyType: any;
  numberOfFellowTravellers: string;
  from: string;
  to: string;
  returnDate: Date;
  luggage: string;
  dateOfBirth: Date;
  wheelchair: string;
  gender: any;
  hospitalizationDate: Date;
  residence: string;
  comment: string;
  deathDate: Date;
  funeralDate: Date;
  bookingNumber: string;
  airline: string;
  isAirLineBooked: string;
}